/**
 *
 * Bar Progress
 *
 */
import React from 'react';

import { Box, HStack, BoxProps } from '@chakra-ui/react';

import { customTheme } from '../../../../../theme';

export interface BarProgressProps extends BoxProps {
  value: number;
  total: number;
  isLoading?: boolean;
  showBorder?: boolean;
}

export const BarProgress: React.FC<BarProgressProps> = props => {
  const {
    value,
    total,
    isLoading,
    color = '#9cc960',
    showBorder = false,
    ...rest
  } = props;
  const w = !total ? 100 : (value / total) * 100;

  return (
    <HStack
      w="full"
      borderRadius="full"
      h="10px"
      overflow="hidden"
      spacing={0}
      border="1.5px solid"
      borderColor="white"
      bg={customTheme.colors.gray['100']}
      position="relative"
      {...rest}
    >
      {!isLoading && (
        <Box
          w={`${w}%`}
          maxW="full"
          bg={color}
          h="10px"
          borderRightRadius="full"
          position="absolute"
          {...(showBorder
            ? { border: '1.5px solid', borderLeft: '0px', borderColor: 'white' }
            : {})}
        />
      )}
    </HStack>
  );
};
